import { render, staticRenderFns } from "./inactive-subscription-modal.vue?vue&type=template&id=56fd6959&scoped=true&lang=pug"
import script from "./inactive-subscription-modal.vue?vue&type=script&lang=ts"
export * from "./inactive-subscription-modal.vue?vue&type=script&lang=ts"
import style0 from "./inactive-subscription-modal.vue?vue&type=style&index=0&id=56fd6959&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fd6959",
  null
  
)

export default component.exports